import colors from '@designSystem/colors';
import { dayjs } from '@app/utils';
import Lang from '@lang/en';
import { NullableString } from '@app/common/types';

const utc = 'utc';

export const apiTestTypeToDisplayName: { [key: string]: string } = {
  antigen_day_2: Lang.healthCheckAntigenTestLabelD2,
  antigen_fit_to_fly_self: Lang.healthCheckAntigenTestLabelSelfFTF,
  antigen_fit_to_fly_clinician: Lang.healthCheckAntigenTestLabelClinicianFTF,
  antigen: Lang.healthCheckAntigenTestLabel,
  rt_pcr_day_2: Lang.healthCheckPCRTestLabelD2,
  rt_pcr_day_5: Lang.healthCheckPCRTestLabelD5,
  rt_pcr_day_8: Lang.healthCheckPCRTestLabelD8,
  rt_pcr_fit_to_fly_self: Lang.healthCheckPCRTestLabelSelfFTF,
  rt_pcr_fit_to_fly_clinician: Lang.healthCheckPCRTestLabelClinicianFTF,
  rt_pcr: Lang.healthCheckPCRTestLabel,
};

export const getTestTypeLabel = (
  testType: NullableString,
  testCategory?: NullableString
): string => {
  if (testType && testCategory)
    return apiTestTypeToDisplayName[`${testType}_${testCategory}`];

  if (testType) return apiTestTypeToDisplayName[testType as string];

  return '';
};

export const getDiffFromNow = (timerEnd: number): number => {
  const now = dayjs().tz(utc);
  return dayjs(timerEnd).tz(utc).diff(now);
};

export const getTimeElapsed = (timerEnd: number): string => {
  const timeElapsedTimestamp = getDiffFromNow(timerEnd);
  const timeElapsed = dayjs(timeElapsedTimestamp).tz(utc).format('m:ss');
  return timeElapsed;
};

const timerLimit = -300000;

const isReady = (timeElapsedTimestamp: number) => {
  return timeElapsedTimestamp <= 0 && timeElapsedTimestamp >= timerLimit;
};

const isExpired = (timeElapsedTimestamp: number) => {
  return timeElapsedTimestamp <= timerLimit;
};

export const timeToColor = (timerEnd: number): string => {
  if (!timerEnd) {
    return colors.amber;
  }
  const timeElapsedTimestamp = getDiffFromNow(timerEnd);
  if (isExpired(timeElapsedTimestamp)) {
    return colors.red;
  }
  if (isReady(timeElapsedTimestamp)) {
    return colors.amber;
  }
  return colors.blue;
};

const addLabel = (value: string): string => {
  return `${Lang.healthCheckTestTimerLabelText} (${value})`;
};

export const timeToLabel = (timerEnd: number, withLabel?: boolean): string => {
  const getLabel = (value: string) => (withLabel ? addLabel(value) : value);

  if (!timerEnd) {
    return Lang.healthCheckTestPerformedWaitingText;
  }
  const timeElapsedTimestamp = getDiffFromNow(timerEnd);
  if (isExpired(timeElapsedTimestamp)) {
    return Lang.healthCheckTestPerformedExpiredText;
  }
  if (isReady(timeElapsedTimestamp)) {
    return Lang.healthCheckTestPerformedReadyText;
  }
  return getLabel(getTimeElapsed(timerEnd));
};
